export function visualCountingSort(array,min,max){
  let count = new Array(max+1).fill(0);
  let animations = [];
  let reads = 0;
  let writes = 0;

  for (let i=0; i<array.length; i++){
    let pos = array[i];
    count[pos] += 1;
    reads++;
    animations.push([0,i,array[i],reads,writes]);
  }

  let j = 0;
  for (let i=min; i<=max+1; i++){
    while (count[i]>0){
      array[j] = i;
      writes++;
      animations.push([1,j,i,reads,writes]);
      j++;
      count[i]--;
    }
  }
  return animations
}
